module.exports = __webpack_public_path__ + "static/media/check-white.97e209e4.svg";